import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { LoginLogoutActionTypes } from '../../../auth/user-auth/store/actions/login-logout.action';
import { CountryType } from '../../../model';
import { SiteConnector } from '../../../site-context/connectors';
import { normalizeHttpError, withdrawOn } from '../../../util';
import { UserActions } from '../actions';
import { DeliveryCountriesActions } from '../actions/delivery-countries.action';

@Injectable()
export class DeliveryCountriesEffects {
  private contextChange$ = this.actions$.pipe(ofType(LoginLogoutActionTypes.Logout));

  loadDeliveryCountries$: Observable<DeliveryCountriesActions> = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.DeliveryCountriesActionTypes.LoadDeliveryCountries),
      exhaustMap((action: UserActions.LoadDeliveryCountries) =>
        this.connector.getCountriesByType(action.userId, CountryType.SHIPPING).pipe(
          map((countries) => new UserActions.LoadDeliveryCountriesSuccess(countries)),
          catchError((error) => of(new UserActions.LoadDeliveryCountriesFail(normalizeHttpError(error))))
        )
      ),
      withdrawOn(this.contextChange$)
    )
  );

  constructor(private actions$: Actions, private connector: SiteConnector) {}
}
